var podcast_filters = (function( $ ) {

    var $podcast_filters;

    var $select;

    var _init = function () {
        $podcast_filters = $( '#podcast-tag-select' );

        $select = $podcast_filters.find('select.podcast-tags-select-2').first().select2({
            placeholder : 'Select Topic',
            minimumResultsForSearch : Infinity,
            dropdownParent : $podcast_filters,
            allowClear : true,
        });

        $select.data( 'select2' ).$dropdown.addClass( 'podcast-tag-filter-dropdown' );
        $select.data( 'select2' ).$container.addClass( 'podcast-tag-filter-select-wrapper' );

        $select.on('change', function () {
            $podcast_filters.submit();
        })
    }

    if ( $( '#podcast-tag-select' ).length > 0 ) {
        $( document ).ready( _init );
    }

    return {};

})( jQuery );

module.exports = podcast_filters;
